import { render, staticRenderFns } from "./SafetyObservationEdit.vue?vue&type=template&id=2d520bab&"
import script from "./SafetyObservationEdit.vue?vue&type=script&lang=js&"
export * from "./SafetyObservationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports